import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import GroupList from './GroupList';

// 画面遷移作成
const MainStack = createNativeStackNavigator();

/** ================================
*  協力組織画面ナビゲーション
*  ================================*/
export default function GroupNavigator() {
  return (
    <MainStack.Navigator screenOptions={{ headerShown: false }}>
      <MainStack.Screen name="GroupList" component={GroupList} options={{ title: '協力組織 一覧' }} />
    </MainStack.Navigator>
  );
}
